<template>
    <div class="mt-3 text-center">
        <div class="text-h6 font-weight-bold">{{ readable_default_tarif }}</div>
        <div style="font-size: 10px; position: relative; top: -1px" v-if="show_frais_gestion">
            (+ frais gestion)
        </div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    name: 'Tarification_Solo',
    props: ['tarifs', 'course'],
    computed: {
        ...mapStores(useMainStore),
        default_tarif() {
            const all_courses = this.mainStore.module.courses.list;
            const default_tarif = this.tarifs.get_default_tarif_on_home(all_courses);
            return default_tarif;
        },
        show_frais_gestion() {
            return this.mainStore.module.metadatas?.exclure_taxe != '1' && this.default_tarif != 0;
        },
        readable_default_tarif() {
            const default_tarif = this.default_tarif;
            if (default_tarif == 0) {
                return "Gratuit";
            }
            return default_tarif + "€";
        }
    },



}
</script>

<style scoped></style>